module.exports = __webpack_public_path__ + "static/media/Logo.3a44ba1c.svg";